import { memo } from 'react';

import clsx from 'clsx';
import { useAtom } from 'jotai';

import TableRow from '@mui/material/TableRow';

import { UserDateColumn } from '../fileSystemTableColumn/userDateColumn/UserDateColumn';

import { FileActionsColumn } from './fileRowColumn/fileActionsColumn/FileActionsColumn';
import { FileNameColumn } from './fileRowColumn/fileNameColumn/FileNameColumn';

import css from './FileRow.module.css';

import { selectedFileAtom } from 'v2/atoms/fileSystemAtom';
import { FileModel } from 'v2/types/FileSystemModel';

interface FileRowProps {
  file: FileModel;
  depth: number;
  onRevalidate: VoidFunction;
}

export const FileRow = memo<FileRowProps>(({ file, depth, onRevalidate }) => {
  const [selectedFile, setSelectedFile] = useAtom(selectedFileAtom);

  const handleSelect = () => {
    if (selectedFile?.id === file.id) {
      setSelectedFile(null);
    } else {
      setSelectedFile(file);
    }
  };

  return (
    <TableRow className={clsx(css.fileRow, selectedFile?.id === file.id && css.selected)} onClick={handleSelect} hover>
      <FileNameColumn file={file} depth={depth} />

      <UserDateColumn user={file.uploadedBy} date={file.uploadDate} />

      <UserDateColumn user={file.modifiedBy} date={file.modifiedDate} />

      <FileActionsColumn file={file} onRevalidate={onRevalidate} />
    </TableRow>
  );
});

FileRow.displayName = 'FileRow';
